// Nationality demonyms — kept in lockstep with the admin portal's agentFields list so a
// vendor/purchaser created in the agent app reads identically in the admin portal.
// Malaysian is pinned first (default & most common); 'Other' is the catch-all.
const NATIONALITY_DEMONYMS = [
  'Afghan', 'Albanian', 'Algerian', 'American', 'Andorran', 'Angolan',
  'Antiguan and Barbudan', 'Argentine', 'Armenian', 'Australian', 'Austrian',
  'Azerbaijani', 'Bahamian', 'Bahraini', 'Bangladeshi', 'Barbadian', 'Belarusian',
  'Belgian', 'Belizean', 'Beninese', 'Bhutanese', 'Bolivian', 'Bosnian',
  'Botswanan', 'Brazilian', 'Bruneian', 'Bulgarian', 'Burkinabè', 'Burmese',
  'Burundian', 'Cabo Verdean', 'Cambodian', 'Cameroonian', 'Canadian',
  'Central African', 'Chadian', 'Chilean', 'Chinese', 'Colombian', 'Comoran',
  'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 'Cypriot', 'Czech', 'Danish',
  'Djiboutian', 'Dominican', 'Dutch', 'East Timorese', 'Ecuadorian', 'Egyptian',
  'Emirati', 'Equatorial Guinean', 'Eritrean', 'Estonian', 'Eswatini', 'Ethiopian',
  'Fijian', 'Finnish', 'French', 'Gabonese', 'Gambian', 'Georgian', 'German',
  'Ghanaian', 'Greek', 'Grenadian', 'Guatemalan', 'Guinean', 'Guinea-Bissauan',
  'Guyanese', 'Haitian', 'Honduran', 'Hungarian', 'Icelandic', 'Indian',
  'Indonesian', 'Iranian', 'Iraqi', 'Irish', 'Israeli', 'Italian', 'Ivorian',
  'Jamaican', 'Japanese', 'Jordanian', 'Kazakh', 'Kenyan', 'Kiribati',
  'Kosovar', 'Kuwaiti', 'Kyrgyz', 'Lao', 'Latvian', 'Lebanese', 'Liberian',
  'Libyan', 'Liechtensteiner', 'Lithuanian', 'Luxembourgish', 'Macedonian',
  'Malagasy', 'Malawian', 'Maldivian', 'Malian', 'Maltese', 'Marshallese',
  'Mauritanian', 'Mauritian', 'Mexican', 'Micronesian', 'Moldovan', 'Monégasque',
  'Mongolian', 'Montenegrin', 'Moroccan', 'Mozambican', 'Namibian', 'Nauruan',
  'Nepali', 'New Zealander', 'Nicaraguan', 'Nigerien', 'Nigerian', 'North Korean',
  'Norwegian', 'Omani', 'Pakistani', 'Palauan', 'Palestinian', 'Panamanian',
  'Papua New Guinean', 'Paraguayan', 'Peruvian', 'Filipino', 'Polish',
  'Portuguese', 'Qatari', 'Romanian', 'Russian', 'Rwandan',
  'Saint Kitts and Nevis', 'Saint Lucian', 'Saint Vincentian', 'Samoan',
  'San Marinese', 'São Toméan', 'Saudi', 'Senegalese', 'Serbian', 'Seychellois',
  'Sierra Leonean', 'Singaporean', 'Slovak', 'Slovenian', 'Solomon Islander',
  'Somali', 'South African', 'South Korean', 'South Sudanese', 'Spanish',
  'Sri Lankan', 'Sudanese', 'Surinamese', 'Swedish', 'Swiss', 'Syrian',
  'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 'Togolese', 'Tongan',
  'Trinidadian and Tobagonian', 'Tunisian', 'Turkish', 'Turkmen', 'Tuvaluan',
  'Ugandan', 'Ukrainian', 'British', 'Uruguayan', 'Uzbek', 'Vanuatuan',
  'Vatican', 'Venezuelan', 'Vietnamese', 'Yemeni', 'Zambian', 'Zimbabwean',
];

export const DEFAULT_NATIONALITY = 'Malaysian';

// A few demonyms read as a race rather than a nationality here — 'Chinese' names the
// ethnicity in Malaysia, so people look for 'China' and think the list is missing it.
// Those entries carry the country in brackets. Only the LABEL changes: the stored
// value stays the bare demonym ('Chinese'), so nothing already saved has to move.
// Mirrors NATIONALITY_LABEL_OVERRIDES in the admin portal's utils/agentFields.js.
const NATIONALITY_LABEL_OVERRIDES = {
  Chinese: 'Chinese (China)',
};

/**
 * How a stored nationality value should be shown. Use it everywhere a nationality is
 * displayed, so the option someone picked reads the same way back on the detail page.
 * Returns the value untouched (including null/undefined) when there is no override.
 */
export const nationalityLabel = (n) => NATIONALITY_LABEL_OVERRIDES[n] || n;

export const NATIONALITY_OPTIONS = [
  'Malaysian',
  ...NATIONALITY_DEMONYMS.filter((n) => n !== 'Malaysian'),
  'Other',
].map((n) => ({ value: n, label: nationalityLabel(n) }));

// Malaysians identify with an IC; everyone else with a passport.
export const isMalaysian = (n) => !n || n === DEFAULT_NATIONALITY || n === 'Malaysia';
